import { cloneDeep } from "lodash";
import { useEffect, useState } from "react"
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "@apollo/client";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material"
import { CREATE_PROJECT, UPDATE_PROJECT } from "../../../graphql/mutations/ProjectEditContext";
import { useSnackbar } from "../../../hooks";
import { FolderSelector, GrayButton, TextAreaFull, TextField } from "../../common";

const ProjectModal = ({ onClose, onSave, open, project, siteId }) => {

  const initalProject = {
    name: "",
    description: "",
    projectFields: [],
    siteId: siteId,
    linkedFolderId: null,
    //projectViews: []
  };

  const intl = useIntl();
  const snackbar = useSnackbar();

  const [internalProject, setInternalProject] = useState();
  const [linkedFolder, setLinkedFolder] = useState({});

  useEffect(() => {
    if (project) {
      setInternalProject(project);
    } else {
      setInternalProject(initalProject)
    }
  }, [project]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  }

  const [createProject, { data: createProjectData, loading: createProjectLoading, error: createProjectError }] = useMutation(CREATE_PROJECT);
  const [updateProject, { data: updateData, loading: loadingData, error: updateError }] = useMutation(UPDATE_PROJECT);

  const handleCreate = () => {
    createProject({ variables: { project: internalProject } });
  }

  const handleShiftKeyDown = (e) => e.shiftKey && e.stopPropagation();
  const handleShiftKeyUp = (e) => (e.key === "Shift") && e.stopPropagation();

  const handleUpdate = () => {
    var temp = cloneDeep(internalProject);
    delete temp.__typename;
    delete temp.projectViews;

    temp.projectFields = temp.projectFields.map(n => {
      return { id: n.fieldId, name: n.name, type: n.type, settings: n.jsonFieldSettings };
    });

    updateProject({ variables: { project: temp } });
  }

  useEffect(() => {
    if (createProjectData && createProjectData?.projects?.createProject?.success) {
      snackbar.success(<FormattedMessage id="project.created" />);
      onSave?.(createProjectData.projects.createProject.project);
    } else if (createProjectData && !createProjectData?.createProject?.success) {
      snackbar.error(<FormattedMessage id="project.errorSave" />);
    }
    else if (createProjectError) {
      snackbar.error(<FormattedMessage id="project.errorSave" />);
    }
  }, [createProjectData, createProjectError])

  useEffect(() => {
    if (updateData && updateData?.projects?.updateProject?.success) {
      snackbar.success(<FormattedMessage id="project.updated" />);
      onSave?.(updateData?.projects?.updateProject?.project);
    } else if (updateData && !!(updateData?.projects?.updateProject?.success)) {
      snackbar.error(<FormattedMessage id="project.errorSave" />);
    }
    else if (updateError) {
      snackbar.error(<FormattedMessage id="project.errorSave" />);
    }
  }, [updateData, updateError])

  const onChangeTitle = (value) => {
    setInternalProject({ ...internalProject, name: value });
  }

  const onChangeDescription = (value) => {
    setInternalProject({ ...internalProject, description: value });
  }

  const getFolderName = folder => (folder ? (folder.name || folder.folderName) : "");

  const handleLinkedFolderSelected = (folder) => {
    const { folderId: linkedFolderId } = folder;
    setInternalProject({ ...internalProject, linkedFolderId });
    setLinkedFolder(folder);
  };

  return internalProject && (

    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      onClose={handleClose}
      onKeyDown={handleShiftKeyDown}
      onKeyUp={handleShiftKeyUp}
      open={open}
    >

      <DialogTitle>
        {!(internalProject?.projectId) ? (<FormattedMessage id="project.newproject" />) : (<FormattedMessage id="project.editproject" />)}
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField value={internalProject.name} onChange={e => onChangeTitle(e.target.value)} label={<FormattedMessage id="project.project" />} />
          </Grid>
          <Grid item xs={12}>
            <TextAreaFull
              label={<FormattedMessage id="project.description" />}
              name="description"
              onChange={e => onChangeDescription(e.target.value)}
              placeholder={intl.formatMessage({ id: "project.description" })}
              rows="6"
              rowsMax="6"
              shrink
              value={internalProject.description}
            />
          </Grid>
          <Grid item xs={12}>
            <FolderSelector
              allowClear
              initialFolderId={internalProject.linkedFolderId}
              label={<FormattedMessage id="project.linkedFolderSelctor.label" />}
              onChange={handleLinkedFolderSelected}
              value={{ name: getFolderName(linkedFolder) }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Box align="right"></Box>
        <GrayButton marginRight={8} disabled={false} onClick={handleClose}><FormattedMessage id="btn.cancel" /></GrayButton>
        {!(internalProject?.projectId) && (<Button variant="contained" size="small" disabled={false} onClick={n => handleCreate()}><FormattedMessage id="btn.create" /></Button>)}
        {!!(internalProject?.projectId) && (<Button variant="contained" size="small" disabled={false} onClick={n => handleUpdate()}><FormattedMessage id="btn.save" /></Button>)}
      </DialogActions>

    </Dialog>

  );
}

export default ProjectModal;
